import { Grid, Box } from '@chakra-ui/react'
import { FC, useMemo, useEffect } from 'react'

import useReportBudget from '@hook/budget/use-report'
import useFilters from '@hook/shared/use-filters'
import useLayout from '@hook/shared/use-layout'
import useSessions from '@hook/shared/use-sessions'

import Layout from '@component/Layout'
import LayoutEmpty from '@component/Layout/Empty'
import LayoutFilters from '@component/Layout/Filters'
import LayoutLoader from '@component/Layout/Loader'
import TableGrid from '@component/Layout/TableGrid'
import GridQuantity from '@component/Layout/TableGrid/GridQuantity'
import LayoutTools from '@component/Layout/Tools'

import { disableActionsByDefault } from '@helper/budget/disableActionsByDefault'

const ReportBudget: FC = () => {
  const { menuToggle } = useLayout()
  const { getFilters } = useFilters()

  const {
    loading,
    headers,
    handleLocalParams,
    actions,
    data,
    filename,
    params,
    pagination,
    query,
    filters,
    setFilters,
    getData,
    filtersList,
    clearAllFilters,
    handleUpdateParams
  } = useReportBudget()

  const { hasSessions } = useSessions()

  const height = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 30px)'
          : '100vh'
        : hasSessions
        ? 'calc(100vh - 160px)'
        : 'calc(100vh - 142px)',
    [menuToggle, hasSessions]
  )

  const tableHeight = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 187px)'
          : 'calc(100vh - 155px)'
        : hasSessions
        ? 'calc(100vh - 328px)'
        : 'calc(100vh - 296px)',
    [menuToggle, hasSessions]
  )

  useEffect(() => {
    handleLocalParams()

    getFilters({
      companies: true,
      centers: true,
      compactCategories: true,
      yearBudget: true,
      monthBudget: true,
      historicBudget: true,
      operationBudget: true,
      visualization: true,
      managerOperations: true,
      dimension: true
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // return <MaintenancePage />

  return (
    <Layout title="Alertas de Compra">
      <Grid
        w="100vw"
        bg="white"
        h={height}
        templateColumns={!filters ? '100vw' : '260px calc(100vw - 260px)'}
      >
        {filters && (
          <LayoutFilters
            filters={filtersList}
            values={params}
            onChange={handleUpdateParams}
            loading={loading}
            canCancel={loading}
            onFilter={getData}
            onClearAllFilters={clearAllFilters}
          />
        )}
        <Box>
          <LayoutTools
            title={filename}
            filters={filters}
            actions={actions}
            toggleFilters={setFilters.toggle}
            isDisabled={loading || data.length === 0}
            disableActionsByDefault={disableActionsByDefault}
          />
          {loading ? (
            <LayoutLoader
              title="Recuperando informações..."
              message="Aguarde enquanto buscamos os registros no banco de dados"
            />
          ) : data.length === 0 ? (
            <LayoutEmpty
              title="Nada encontrado!"
              message="Filtre sua busca ao lado para obter informações"
            />
          ) : (
            <>
              <GridQuantity data={data} />

              <TableGrid
                id="purchase-alert-table"
                headers={headers}
                data={data}
                itsSortable={true}
                entity="budget-report"
                pagination={pagination}
                query={query}
                height={tableHeight}
                isPaged
              />
            </>
          )}
        </Box>
      </Grid>
    </Layout>
  )
}

export default ReportBudget
